<template>
  <div class='box'>
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
          <img src="../assets/img/返回.png" alt />
          返回上一页
        </div>
      </div>

      <div class="class" v-for="(item,index) in class_list" :key="index">
          <div class="class_title clearfix">
            <img src="../assets/课程.png" alt />
            <span>{{item.title}}</span>
          </div>

          <div class="class_list" v-if="item.subject">
            <div class="class_list_title clearfix">
              <span style="width:250px">科目名称</span>
              <span style="width:422px"></span>
              <!-- <span style="width:200px">相关操作</span> -->
            </div>
            <div class="class_list_tr clearfix" v-for="(item1,index) in item.subject" :key="index">
              <span style="width:250px">{{item1.title}}</span>
              <span style="width:422px"></span>
              <span style="width:200px">
                <div
                  class="btn"
                  @click="study_click(item,item1.chapter_id,item1.title)"
                >{{item1.is_learn==0?'开始学习':'继续学习'}}</div>
              </span>
            </div>
          </div>
          <div class="class_list" v-else>
            <div class="class_list_title clearfix">
              <span style="width:250px">科目名称</span>
              <span style="width:422px"></span>
              <!-- <span style="width:200px">相关操作</span> -->
            </div>
            <div class="class_list_tr clearfix">
              <span style="width:250px">{{item.title}}</span>
              <span style="width:422px"></span>
              <span style="width:200px">
                <div class="btn" @click="one_study_click(item)">{{item.is_learn==0?'开始学习':'继续学习'}}</div>
              </span>
            </div>
          </div>
        </div>

        <el-dialog
          title="提示"
          :visible.sync="isShowModal"
          style="min-width: 520px;"
          width="50%">
          <div style="text-align:center">
            <p style="padding:20px;font-size:20px">课程已过期，如需继续学习，请联系客服优惠开通</p>
            <img src="../assets/img/saoma.png" alt="" style="width:400px;height:400px">
          </div>
          <span slot="footer" class="dialog-footer" style="display:flex;justify-content:center">
            <el-button type="primary" style="width:80%" @click="isShowModal = false">关 闭</el-button>
          </span>
        </el-dialog>


  </div>
</template>

<script>
import {
  Course
} from "@/api/index";
export default {
  name: '',
  data() {
    return {
        class_list: [], //所有课程
        curr_class_list:[],//当前选择的课程
        isShowModal:false,
    };
  },
  computed:{
  },
  watch:{
  },
  methods: {
    course() {
      Course(1).then(res => {
        let data = res;
        console.log(res)
        if(data.length==0) return
        // 整理显示所有课程
        for(let item of data){
          if(item.course_list.length!=0)
            for(let item2 of item.course_list){
                this.class_list.push(item2)
            }
        }
        console.log(this.class_list)
        this.curr_class_list = this.class_list[0].course_list
        this.navNum = this.class_list[0].id
        // for (let i = 0; i < this.class_list.length; i++) {
        //   if (this.class_list[i].type == 8) {
        //     this.class_list.splice(i, 1);
        //   }
        // }
        
      });
    },
    // 点击学习
    study_click(item, chapter_id, title) {
      return this.showModalM()
      if (item.type == 3) {
        sessionStorage.setItem("course_id", item.course_id);
        sessionStorage.setItem("chapter_id", chapter_id);
        this.$router.push({
          path: "question_bank",
          query: {
            course_id: item.course_id,
            chapter_id: chapter_id,
            name: title,
            type: item.type
          }
        });
      }else if(item.type == 9){
        this.$router.push({
          path: "handouts",
          query: {
            course_id: item.course_id,
            chapter_id: chapter_id
          }
        });
      } else {
        sessionStorage.setItem("course_id", item.course_id);
        sessionStorage.setItem("chapter_id", chapter_id);
        this.$router.push({
          name: "visit_class",
          query: { course_id: item.course_id, chapter_id: chapter_id }
        });
      }
    },
    // 单课程
    one_study_click(item) {
      return this.showModalM()
      sessionStorage.clear();
      sessionStorage.setItem("course_id", item.course_id);
      sessionStorage.setItem("chapter_id", 0);
      if(!item.chapter_id)
        item.chapter_id=0
      if(item.type == 9){
        this.$router.push({
          path: "handouts",
          query: {
            course_id: item.course_id,
            chapter_id: item.chapter_id
          }
        });
      }else{
        this.$router.push({
          name: "visit_class",
          query: { course_id: item.course_id }
        });
      }
    },
    showModalM(){
      this.isShowModal=true
    },




  },
  created(){
      this.course();
  }
};
</script>

<style lang='scss' scoped>
.box{
    width: 1000px;
    margin: 0 auto;
    .bread_nav {
        padding: 12px 23px 12px 74px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(238, 238, 238, 1);
        margin-bottom: 16px;

        .return {
        font-size: 16px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        float: left;
        margin-right: 162px;
        line-height: 28px;
        margin-top: 5px;
        cursor: pointer;

        img {
            float: left;
            width: 28px;
            height: 28px;
            margin-right: 12px;
        }
        }
    }
    .class {
      background-color: #fff;
      border: 1px solid #eee;
      margin-bottom: 32px;
      .class_title {
        padding: 24px 0 20px 33px;
        border-bottom: 1px soli #eee;
        img {
          width: 32px;
          height: 32px;
          float: left;
        }
        span {
          float: left;
          margin-left: 16px;
          font-size: 20px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
        }
      }

      .class_list {
        .class_list_title {
          padding: 24px 0;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;

          span {
            display: block;
            float: left;
            text-align: center;
            &:last-of-type {
              float: right;
            }
          }
        }
        .class_list_tr {
          padding: 24px 0;
          border-bottom: 1px solid #eee;
          span {
            display: block;
            float: left;
            text-align: center;
            &:last-of-type {
              float: right;
            }
          }
        }
        .btn {
          width: 72px;
          height: 25px;
          background: rgba(250, 220, 30, 1);
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          text-align: center;
          line-height: 25px;
          margin: auto;
          cursor: pointer;
        }
      }
    }
}
</style>
